import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody } from '@/api/types';
import { getTXCenterApiUrl } from './tx-centers.paths';
import {
  NewTXCentersFormBody,
  PaginatedTXCentersListFilters,
  PatchTXCentersBodyFormBody,
  TXCenter,
} from './tx-centers.types';

const getTXCentersList = async (params: PaginatedTXCentersListFilters) => {
  const res = await http.get<PaginatedApiResponseBody<TXCenter>>(getTXCenterApiUrl.list(), { params });
  return res.data.data;
};

const getTXCenterById = async (txCenterId: string): Promise<TXCenter> => {
  const res = await http.get<ApiResponseBody<TXCenter>>(getTXCenterApiUrl.txCenterById(txCenterId));
  return res.data.data;
};

const updateTXCenterById = async (txCenterId: string, body: PatchTXCentersBodyFormBody) => {
  const res = await http.patch<ApiResponseBody<TXCenter>>(getTXCenterApiUrl.txCenterById(txCenterId), body);
  return res.data.data;
};

const updateTXCenterNotes = async (
  txCenterId: string,
  body: Pick<PatchTXCentersBodyFormBody, 'notes' | 'trialProgramNotes'>,
) => {
  const res = await http.patch<ApiResponseBody<TXCenter>>(getTXCenterApiUrl.txCenterNotes(txCenterId), body);
  return res.data.data;
};

const createTXCenter = async (body: NewTXCentersFormBody) => {
  const res = await http.post<ApiResponseBody<TXCenter>>(getTXCenterApiUrl.list(), body);
  return res.data.data;
};

export const txCentersApiFetcher = {
  getTXCentersList,
  getTXCenterById,
  updateTXCenterById,
  updateTXCenterNotes,
  createTXCenter,
};
